<div
  id="profile-uploader-component"
  class="profile-thumbnail-component"
  fxLayout="column"
  fxLayoutAlign="center center"
  >
  <div fxLayout="row" fxLayoutAlign="center center" class="thumbnail-box">
    @if (!takePhotoMode && !webcamSnapshot) {
      <img
        #photo
        class="thumbnail-img"
        [src]="photoSrc"
        alt="Default Photo Image"
        (error) = "handleImageError()"
        />
    }
    @if (webcamSnapshot) {
      <img
        class="thumbnail-img"
        src="{{ webcamSnapshot }}"
        alt="Profile Photo Thumbnail"
        />
    }
    @if (webcamLoading && takePhotoMode) {
      <div
        fxLayout="column"
        fxLayoutAlign="center center"
        >
        <mat-spinner></mat-spinner>
      </div>
    }
    <video
      #video
      id="video"
      autoplay
      width="365"
      height="274"
      [hidden]="webcamLoading || !takePhotoMode"
    ></video>
    <canvas
      #webcamCanvas
      id="webcam-canvas"
      width="365"
      height="274"
      [hidden]="true"
      >
    </canvas>
  </div>
  @if (showProgressBar) {
    <mat-progress-bar
      mode="determinate"
      value="{{ uploader.queue[0].progress }}"
      >
    </mat-progress-bar>
  }

  <input
    id="fileInput"
    name="file"
    type="file"
    #fileUploader
    ng2FileSelect
    [uploader]="uploader"
    placeholder="No file chosen"
    accept="image/*"
    [hidden]="true"
    alt="Profile Pic"
    (onFileSelected)="fileSelected()"
    />
  <div fxLayout="row" fxLayoutAlign="center center" class="profile-thumbnail-options">
    <button
      mat-raised-button
      type="button"
      color="primary"
      (click)="preselectFile(); fileUploader.click()"
      [disabled]="takePhotoMode"
      >
      <mat-icon>folder_open</mat-icon>
      Select File
    </button>

    @if (!takePhotoMode) {
      <button
        mat-raised-button
        type="button"
        color="primary"
        [disabled]="webcamError"
        (click)="enableWebcam()"
        >
        <mat-icon>camera</mat-icon>
        Use Webcam
      </button>
    }

    @if (takePhotoMode) {
      <button
        mat-raised-button
        type="button"
        color="primary"
        (click)="capture()"
        [disabled]="webcamError || webcamLoading"
        >
        <mat-icon>camera</mat-icon>
        Take Photo
      </button>
    }

    <button
      mat-raised-button
      type="button"
      color="primary"
      [disabled]="disableUploadBtn"
      (click)="uploadFile()"
      >
      <mat-icon>cloud_upload</mat-icon>
      Update Profile Image
    </button>
  </div>
  @if (webcamError) {
    <div class="webcam-error">
      Webcam is unavailable.
    </div>
  }
</div>
